import { get } from '@api/request';

export const fetchActivityLogs = async (
  { litigationService },
  authenticationToken,
  { caseID },
) => {
  const url = `${litigationService}/litigation/case/${caseID}/activity`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const downloadActivityFile = async (
  { litigationService },
  authenticationToken,
  { activityID, s3ID },
) => {
  const url = `${litigationService}/litigation/caseactivity/${activityID}/file/${s3ID}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then(response => response.blob())
    .then(blobby => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3ID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};
